import { useState } from "react";
import API from "../api";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.jpg";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email) {
      return alert("Please enter your email address.");
    }

    try {
      setLoading(true);

      const res = await API.post("/auth/forgot-password", {
        email,
      });

      alert(
        res.data.msg ||
        "Password reset link sent to your email."
      );
    } catch (err) {
      alert(
        err?.response?.data?.msg ||
        "Unable to send reset link."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow w-full max-w-md">

        <img
          src={logo}
          alt="Logo"
          className="h-20 mx-auto mb-2"
        />

        <h2 className="text-2xl font-bold text-center mb-6">
          Forgot Password
        </h2>

        <p className="text-sm text-gray-600 text-center mb-6">
          Enter your registered email address and we will send you a password reset link.
        </p>

        <label>Email</label>

        <input
          type="email"
          className="w-full border p-2 rounded mt-1 mb-4"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          onClick={submit}
          disabled={loading}
          className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <p className="text-sm text-center mt-4">
          <Link
            to="/login"
            className="text-green-600 font-semibold"
          >
            Back to Login
          </Link>
        </p>

      </div>
    </div>
  );
}